import { c as _c } from "react/compiler-runtime";
import { MAILING_API } from 'shared/components/dashboard-mail-editor/api/email-api';
import { MailingStatusEnum } from 'shared/enums/mailing-status-enum';
import useUser from 'shared/hooks/use-user';
import { baseFetcher } from 'shared/utils/http-client';
import useSWR from 'swr';
export const useSwrEmailStatusNotification = shouldFetch => {
  const $ = _c(3);
  const {
    user
  } = useUser();
  let t0;
  if ($[0] !== shouldFetch || $[1] !== user) {
    t0 = () => {
      if (!user || !shouldFetch) {
        return;
      }
      return `${MAILING_API}/mailing-options`;
    };
    $[0] = shouldFetch;
    $[1] = user;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  return useSWR(t0, baseFetcher);
};